import { Dropdown, Input, OptionType } from "modules/common";
import { useCountiesAndSettlements } from "modules/common/hooks/useCountiesAndSettlements";
import { UseFormReturn } from "modules/common/hooks/useForm";
import { useEffect, useState } from "react";

export interface AddressFormData {
    county?: OptionType<number | null>;
    settlement?: OptionType<number | null>;
    postalNumber?: string;
    street?: string;
    streetNumber?: string;
}

interface Props<T extends AddressFormData> {
    form: UseFormReturn<T>;
}

export const AddressForm = <T extends AddressFormData>({ form }: Props<T>) => {
    const {
        formData,
        onFormChange,
        labelFor,
        inputPropsFor,
        dropdownPropsFor,
        inputContainer,
        dropdownContainer,
    } = form;
    const [loadCounties, setLoadCounties] = useState(true);
    const {
        countyOptions,
        areCountiesLoading,
        settlementOptions,
        selectedSettlement,
        areSettlementsLoading,
    } = useCountiesAndSettlements({
        settlement: formData.settlement,
        county: formData.county,
        loadCounties,
    });

    useEffect(() => {
        if (!selectedSettlement) return;

        onFormChange({ postalNumber: selectedSettlement.postalNumber } as Partial<T>);
    }, [selectedSettlement]);

    return (
        <>
            {labelFor("county", "Županija")}
            {dropdownContainer(
                <Dropdown
                    isLoading={areCountiesLoading}
                    onMenuOpen={() => setLoadCounties(true)}
                    maxMenuHeight={170}
                    {...dropdownPropsFor("county", countyOptions)}
                    onChange={county =>
                        onFormChange({
                            county,
                            settlement: undefined,
                        } as Partial<T>)
                    }
                />
            )}

            {labelFor("settlement", "Mjesto")}
            {dropdownContainer(
                <Dropdown
                    isLoading={areSettlementsLoading}
                    maxMenuHeight={170}
                    {...dropdownPropsFor("settlement", settlementOptions)}
                    noOptionsMessage={() => "Nema naselja za odabranu županiju"}
                />
            )}

            {labelFor("postalNumber", "Poštanski broj")}
            {inputContainer(
                <Input {...inputPropsFor("postalNumber")} placeholder="10000" />
            )}

            {labelFor("street", "Ulica")}
            {inputContainer(<Input placeholder="Zagrebačka cesta" {...inputPropsFor("street")} />)}

            {labelFor("streetNumber", "Kućni broj")}
            {inputContainer(<Input placeholder="234" {...inputPropsFor("streetNumber")} />)}
        </>
    );
};
